module.exports = __webpack_public_path__ + "static/media/flipCards_icon--active.6445e88d.svg";